import React from 'react';
import { useNavigate } from 'react-router-dom';
import XiTopNav from './XiTopNav';
import XiBottomNav from './XiBottomNav';
import XiBackdrop from './XiBackdrop';
import useSessionUser from '../../hooks/useSessionUser';

/**
 * Shared shell for the secondary destinations.
 * Keeps navigation, backdrop and page rhythm identical across routes so pages
 * differ only in composition, never in visual language.
 */
export default function XiPageShell({
  eyebrow,
  title,
  lede,
  actions = null,
  children,
  className = '',
}) {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated } = useSessionUser();

  return (
    <div className="xi-page-shell">
      <div className="xi-app-frame">
        <XiBackdrop variant="page" />
        <XiTopNav
          user={user}
          isAuthenticated={isAuthenticated}
          onRequireLogin={() => navigate('/login')}
          onLogout={logout}
          onDeactivate={() => navigate('/delete')}
          onOpenSubscription={() => navigate('/plans')}
        />

        <main className={`xi-page ${className}`.trim()}>
          {(eyebrow || title || lede) && (
            <header className="xi-page__head">
              <div>
                {eyebrow && (
                  <span className="xi-page__eyebrow">
                    <i aria-hidden="true" />
                    {eyebrow}
                  </span>
                )}
                {title && <h1 className="xi-page__title">{title}</h1>}
                {lede && <p className="xi-page__lede">{lede}</p>}
              </div>
              {actions && <div className="xi-page__actions">{actions}</div>}
            </header>
          )}

          {children}
        </main>

        <XiBottomNav />
      </div>
    </div>
  );
}
